export const getAttendanceLabel = (destination: string | null): string => {
  if (!destination) {
    return 'No Attendance Punch';
  }

  return `Attendance Punch Available : ${destination}`;
};
